import axios from "axios";

import { samlValidationRequestSchema, samlValidationResultSchema } from "../schemas/saml-validation";

export const validateSaml = async (rootUrl: string, token: string) => {
	const request = samlValidationRequestSchema.parse({ payload: token });
	try {
		const response = await axios.post(`${rootUrl}/v1/sso/validate`, request);
		return samlValidationResultSchema.parse(response.data);
	} catch (error) {
		if (axios.isAxiosError(error) && error.response !== undefined) {
			return samlValidationResultSchema.parse(error.response.data);
		}
		throw error;
	}
};
